export default {
    Cliente_ID: 1,
    chrSerial: '999000000001',
    Session_ID: 'JBWEBETICKET_1',
    LoginLE: '0',
    strDataIni: '2019-02-01T02:00:00.000Z',
    strDataFim: '2019-02-28T03:00:00.000Z',
    Sistema_ID: 1
  }


// WEBPACK FOOTER //
// ./src/mocking/lista-de-apostas-payload.js